import axios from "axios";

// International version - Use environment variable for API URL
const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:4002";
// Ensure URL always ends with trailing slash
const API_BASE_URL = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
const api = axios.create({ baseURL: API_BASE_URL });

// Production servers (configured via .env)
// REACT_APP_API_BASE_URL=https://api-en-dev.healiary.com (dev)
// REACT_APP_API_BASE_URL=https://api-en.healiary.com (production)

// Add JWT token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 Unauthorized responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('accessToken');
      window.location.href = '/sign';
    }
    return Promise.reject(error);
  }
);

export default api;

export const common = {
  baseURL: API_BASE_URL, // Uses REACT_APP_API_BASE_URL from .env
};
